import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const KEY = "csi_ref";
const DAYS = 90;

export const visitorId = () => {
  let v = localStorage.getItem("csi_vid");
  if (!v) { v = (crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/-/g, ""); localStorage.setItem("csi_vid", v); }
  return v;
};

export const getStoredRef = () => {
  try {
    const r = JSON.parse(localStorage.getItem(KEY) || "null");
    if (r && Date.now() - r.ts < DAYS * 864e5) return r;
  } catch { /* ignore */ }
  return null;
};

const storeRef = async (code) => {
  const c = (code || "").trim().toUpperCase();
  if (!/^CSI-[A-Z0-9]{2,20}$/.test(c)) return;
  try {
    const { data } = await api.post("/ambassadors/track", { code: c, visitor_id: visitorId() });
    if (data.valid) localStorage.setItem(KEY, JSON.stringify({ code: data.code, name: data.name, ts: Date.now(), attached: false }));
  } catch { /* ignore */ }
};

export const ReferralTracker = () => {
  const { search } = useLocation();
  const { user } = useAuth();
  useEffect(() => {
    const ref = new URLSearchParams(search).get("ref");
    if (ref) storeRef(ref);
  }, [search]);
  useEffect(() => {
    const r = getStoredRef();
    if (!user || !r || r.attached) return;
    api.post("/ambassadors/attach", { code: r.code, visitor_id: visitorId() }).catch(() => {}).finally(() => {
      localStorage.setItem(KEY, JSON.stringify({ ...r, attached: true }));
    });
  }, [user]);
  return null;
};

export const ReferralRedirect = () => {
  const { code } = useParams();
  const nav = useNavigate();
  useEffect(() => {
    storeRef(code).finally(() => {
      const r = getStoredRef();
      if (r) toast.success(`${r.name}'s CSI Ambassador discount applied: 5% off CSCE and CSP`);
      nav("/courses", { replace: true });
    });
  }, [code, nav]);
  return <div className="p-12 text-center text-sm text-zinc-500" data-testid="referral-redirect">Applying your CSI Ambassador discount…</div>;
};
